const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class MobileCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => {
      this.carousel = this.setupCarousel()
    }, 1000)
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'free',
        slides: {
          perView: 2.6,
          spacing: 10,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('mobile-carousel')) {
  customElements.define('mobile-carousel', MobileCarousel)
}
